import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const ProductNotFound = () => {
  const { t} = useTranslation();

    return (
        <div className="error-area pt-40 pb-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-7 col-lg-8 text-center">
                        <div className="error pt-100">
                            {/* <h1>404</h1> */}
                            <h2>{t("product__product_not_found")}</h2>
                            <p className="mb-50">
                                {t("product__product_not_found_desc")}
                            </p>
                            {/* <form className="searchform mb-50">
                                <input
                                    type="text"
                                    name="search"
                                    id="error_search"
                                    placeholder="Search..."
                                    className="searchform__input"
                                />
                                <button
                                    type="submit"
                                    className="searchform__submit"
                                >
                                    <i className="fa fa-search" />
                                </button>
                            </form> */}
                            <Link
                                to={process.env.PUBLIC_URL + "/shop"}
                                className="error-btn"
                            >
                                {t("product__back_to_shop")}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductNotFound;